import { c as _c } from "react/compiler-runtime";
import classNames from "classnames";
import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import { type ComponentProps } from "react";
import styles from "./SProviderLink.module.css";
export default function SProviderLink(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = classNames(styles.SProviderLink, className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <FilmwebLink className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}